export default __webpack_public_path__ + "static/media/12.6f6d0576.mp3";